export default __webpack_public_path__ + "static/media/loading.8f2c9ce5.svg";